import { render } from "./StakeDistribution.vue?vue&type=template&id=093f0d43"
import script from "./StakeDistribution.vue?vue&type=script&lang=js"
export * from "./StakeDistribution.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/StakeDistribution.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "093f0d43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('093f0d43', __exports__)) {
    api.reload('093f0d43', __exports__)
  }
  
  module.hot.accept("./StakeDistribution.vue?vue&type=template&id=093f0d43", () => {
    api.rerender('093f0d43', render)
  })

}


export default __exports__